import React, { Component } from "react";
import { GridTable } from "../Sidebar/SidebarStyles";
import { AddLobRecord, ReprocessAutoJob, fetchReprocessAutoJOBData, fetchJobFailedRecords, generateExportExcelforAutoJobFailedList } from "../ApiSevices/JobListingApis";
import TablePagination from "@mui/material/TablePagination";
import { Alert, Box, Snackbar, Dialog, Button, DialogContent, DialogContentText, DialogTitle, TextField, IconButton, Tooltip, Grid, Typography, MenuItem, Select, } from "@mui/material";
import { Search, Today } from "@mui/icons-material";
import { Cached } from "@mui/icons-material";
import { Add } from "@mui/icons-material";
import { getbroker } from "../ApiSevices/UserMasterApis";

interface State {
  activeTab: string;
  jobId: string;
  jobDetails: any;
  lobAlias: string;
  lob: string;
  description: string;
  errors: { [key: string]: string };
  loading: boolean;
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarSeverity: "success" | "error" | "info" | "warning";
  jobList: any[];
  selectAll: boolean;
  selectedJob: Set<string>;
  isDialogOpen: boolean;
  isDialogLobOpen: boolean;
  searchQuery: string;
  filteredJobList: any[];
  page: number;
  rowsPerPage: number;
  totalCount: number;
  fromDate: string;
  toDate: string;
  brokerList: { Broker_ID: number; vchBrokerName: string }[];
  selectedBrokerId: number,
  reason: string;
}

interface Props {
  displaysidebar: boolean;
}

const tabs = [
  { key: "failedJobs", label: "Auto Job Failed" },
  { key: "lobAlias", label: "LOB Alias Mapping" },
  // { key: "reprocess", label: "Reprocess Auto Jobs" },
];

const commonTextFieldSx = {
  "& .MuiOutlinedInput-root": { height: 30 },
  "& .MuiOutlinedInput-input": {
    padding: "4px 10px",
    fontSize: "0.875rem"
  }
};

const getMaxToDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const getMinDate = () => {
  const minDate = new Date();
  minDate.setDate(minDate.getDate() - 30); // Set to 30 days ago
  return minDate.toISOString().split('T')[0];
}

class JobMaintenance extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeTab: "failedJobs",
      jobId: "",
      jobDetails: null,
      lobAlias: "",
      lob: "",
      description: "",
      errors: {},
      loading: false,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
      jobList: [],
      selectAll: false,
      selectedJob: new Set<string>(),
      isDialogOpen: false,
      isDialogLobOpen: false,
      searchQuery: "",
      filteredJobList: [], // initialize filtered list
      page: 0,
      rowsPerPage: 100,
      totalCount: 0,
      fromDate: "",
      toDate: "",
      selectedBrokerId: -1,
      brokerList: [],
      reason: ''
    };
  }

  componentDidMount() {
    this.fetchData();
    this.getMastersData();
  }

  getMastersData = async () => {
    try {
      const brokerData = await getbroker();
      this.setState({ brokerList: brokerData?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName)) || [] });
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  }

  fetchData = async (page: number = 0, folderName: string = "") => {
    this.setState({ loading: true });

    try {
      // Fetch data from the API with folderName
      const fetchResData = this.state.activeTab === 'reprocess' ? await fetchReprocessAutoJOBData(page + 1, folderName) : await fetchJobFailedRecords(
        page + 1,
        this.state.rowsPerPage,
        this.state.selectedBrokerId === -1 ? undefined : this.state.selectedBrokerId,
        this.state.fromDate, this.state.toDate,
        folderName,this.state.reason.trim());
      const jobList = fetchResData?.data || [];
      const totalCount = fetchResData?.totalCount || 0;

      // Update the jobList and filteredJobList based on the API response
      this.setState({ jobList, filteredJobList: jobList, totalCount, page, });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChangePage = (_event: unknown, newPage: number) => {
    // Clear the search query if there is any value in it
    if (this.state.searchQuery.trim() !== "") {
      this.setState({ searchQuery: "" }, () => {
        // Fetch all records since the search query is cleared
        this.fetchData(newPage);
      });
    } else {
      // If searchQuery is already empty, just fetch the new page
      this.fetchData(newPage);
    }
  };

  showSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning"
  ) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false });
  };

  handleTabChange = (key: string) => {
    this.setState({ activeTab: key, errors: {} });
    this.handleResetClick();
  };

  handleChange = (field: string, value: string) => {
    this.setState({ [field]: value } as any);
  };

  validateLOBForm = () => {
    const { lobAlias, lob, description } = this.state;
    const errors: { [key: string]: string } = {};
    if (!lobAlias) errors.lobAlias = "LOB Alias is required";
    if (!lob) errors.lob = "LOB is required";
    if (!description) errors.description = "Description is required";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleLOBSubmit = async () => {
    this.setState({ isDialogLobOpen: false });

    const { lobAlias, lob, description } = this.state;
    if (this.validateLOBForm()) {
      this.setState({ loading: true });
      try {
        const response = await AddLobRecord(lobAlias, lob, description);
        if (response?.message) {
          this.showSnackbar(
            `New lobAlias ${lobAlias} ${response?.message}`,
            "success"
          );
        }
      } catch (error) {
        alert("An error occurred while mapping LOB");
        console.error("LOB mapping error:", error);
      } finally {
        this.setState({
          loading: false,
          errors: {},
          lobAlias: "",
          lob: "",
          description: "",
        });
      }
    }
  };

  handleCheckboxChange = (folderName: string, checked: boolean) => {
    this.setState((prevState) => {
      const selectedJob = new Set(prevState.selectedJob);

      if (checked) {
        selectedJob.add(folderName); // Add the FolderName to the selectedJob set
      } else {
        selectedJob.delete(folderName); // Remove the FolderName from the selectedJob set
      }

      // Check if all jobs on the current page are selected to update selectAll state
      const allSelected = prevState?.filteredJobList?.every((job) =>
        selectedJob.has(job.FolderName)
      );

      return {
        selectedJob,
        selectAll: allSelected, // If all jobs are selected, set selectAll to true
      };
    });
  };

  // Handle the select all checkbox change (header checkbox)
  handleSelectAll = (isChecked: boolean) => {
    this.setState((prevState) => {
      const selectedJob = new Set<string>();

      if (isChecked) {
        // If "select all" is checked, add all FolderNames to the selectedJob set
        prevState?.filteredJobList?.forEach((job) =>
          selectedJob.add(job.FolderName)
        );
      }

      return {
        selectedJob,
        selectAll: isChecked, // Set the state of selectAll based on the checkbox
      };
    });
  };

  // Function to filter the job list based on search query
  filterJobList = () => {
    const { jobList, searchQuery } = this.state;
    const trimmedSearchQuery = searchQuery?.trim()?.toLowerCase();

    if (!trimmedSearchQuery) {
      // If searchQuery is empty, show all jobs
      this.setState({ filteredJobList: jobList });
    } else {
      // Filter jobs based on FolderName matching the search query
      const filteredJobList = jobList.filter((job) =>
        job.FolderName.trim().toLowerCase().includes(trimmedSearchQuery)
      );
      this.setState({ filteredJobList });
    }
  };

  handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = e.target.value;

    // Update the search query state
    this.setState({ searchQuery }, () => {
      // If searchQuery is empty, fetch all records
      if (searchQuery.trim() === "") {
        this.fetchData(); // Fetch all records when search is cleared
      }
    });
  };

  handleReasonChange(e: React.ChangeEvent<HTMLInputElement>) {
    const reason = e.target.value;
    this.setState({ reason:reason });
  }

  handleSearchClick = async () => {
    const { searchQuery, page } = this.state;
    const folderName = searchQuery.trim(); // Get the trimmed folder name for the API request

    this.setState({ loading: true });

    try {
      // If searchQuery is not empty, pass it to the API as folderName
      const fetchResData = this.state.activeTab === 'reprocess' ? await fetchReprocessAutoJOBData(
        page + 1,
        folderName
      ) : await fetchJobFailedRecords(
        1,
        this.state.rowsPerPage,
        this.state.selectedBrokerId === -1 ? undefined : this.state.selectedBrokerId,
        this.state.fromDate, this.state.toDate,
        folderName,this.state.reason.trim());
      const jobList = fetchResData?.data || [];
      const totalCount = fetchResData?.totalCount || 0;

      // Update the jobList and filteredJobList based on the API response
      this.setState({
        jobList,
        filteredJobList: jobList,
        totalCount,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleReprocessJobs = async () => {
    const { selectedJob } = this.state;
    if (!selectedJob || selectedJob.size === 0) {
      this.showSnackbar(
        "Please select at least one job to reprocess.",
        "warning"
      );
      return;
    }

    this.setState({ loading: true });
    try {
      const promises = Array.from(selectedJob).map(jobId =>
        ReprocessAutoJob(jobId)
      );
      await Promise.all(promises);
      if (selectedJob.size === 1) {
        this.showSnackbar(
          `Job ${Array.from(selectedJob)[0]} reprocessed successfully.`,
          "success"
        );
      } else {
        this.showSnackbar(
          `Selected jobs reprocessed successfully.`,
          "success");
      };
      this.setState({ selectedJob: new Set() });
      this.fetchData();
    } catch (error) {
      console.error("Error reprocessing jobs:", error);
      this.showSnackbar("Failed to reprocess job(s).", "error");
    } finally {
      this.setState({ loading: false, isDialogOpen: false });
    }
  };

  openReprocessJobidDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  openLobMappingDialog = () => {
    this.setState({ isDialogLobOpen: true, errors: {} });
  };

  handleCloseDialog = () => {
    this.setState({
      isDialogOpen: false,
      isDialogLobOpen: false,
      selectedJob: new Set(),
    });
  };

  handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ fromDate: e.target.value });
  }

  handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ toDate: e.target.value });
  }

  handleBrokerChange = (e: any) => {
    this.setState({ selectedBrokerId: e.target.value as unknown as number });
  }

  handleResetClick = () => {
    this.setState(
      {
        searchQuery: "",
        selectedJob: new Set<string>(),
        selectAll: false,
        page: 0,
        toDate: "",
        fromDate: "",
        reason: '',
        selectedBrokerId: -1
      },
      () => {
        this.fetchData(); // Reload all jobs
      }
    );
  }

  handleExport = async () => {
    this.setState({ loading: true });
    const {
      fromDate,
      toDate,
      selectedBrokerId,
      searchQuery,
      reason
    } = this.state;
    try {
      const fileBlob = await generateExportExcelforAutoJobFailedList(selectedBrokerId === -1 ? undefined : selectedBrokerId, searchQuery, fromDate, toDate,reason.trim());
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;

      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();

      const formattedDate = `${day}${month}${year}`;
      const filename = `AutoJobFailedList_${formattedDate}.xlsx`;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting production report:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  renderTabContent = () => {
    const { activeTab, lobAlias, lob, description, errors, selectedJob, filteredJobList, selectAll, page, rowsPerPage, fromDate, toDate } = this.state;

    switch (activeTab) {
      case "reprocess":
      case "failedJobs":
        return (
          <div className="job-tab-content-autojob">
            <button
              className="autojob-button"
              onClick={this.openReprocessJobidDialog}
              disabled={selectedJob.size === 0 || !selectedJob}
            >
              Reprocess Job(s)
            </button>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mt: 1 }}
            >
              {/* Left Section - Search */}
              <Box display="flex" alignItems={activeTab === 'reprocess' ? "center" : "end"} gap={1}>
                {activeTab === 'failedJobs' &&
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: '500', }}
                    >
                      Select Broker
                    </Typography>
                    <Select
                      value={this.state.selectedBrokerId}
                      onChange={this.handleBrokerChange}
                      size="small"
                      sx={{ minWidth: 120, fontSize: '12px' }}
                    >
                      <MenuItem value={-1} sx={{ fontSize: '12px' }}>All</MenuItem>
                      {this.state.brokerList.map((broker) => (
                        <MenuItem
                          key={broker.Broker_ID}
                          value={broker.Broker_ID}
                          sx={{ fontSize: '12px' }}
                        >
                          {broker.vchBrokerName}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>}
                <TextField
                  size="small"
                  placeholder="Search by Folder Name"
                  value={this.state.searchQuery}
                  onChange={this.handleSearchChange}
                  sx={{
                    "& .MuiInputBase-input::placeholder": { fontSize: "11px" },
                    "& .MuiInputBase-input": { fontSize: "11px" },
                    width: 180,
                  }}
                />

                {activeTab === 'failedJobs' &&
                  <Grid item>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                      Upload From Date
                    </Typography>
                    <TextField
                      name="fromDate"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="medium"
                      value={fromDate}
                      onChange={this.handleFromDateChange}
                      inputProps={{
                        max: getMaxToDate(),
                        min: getMinDate()
                      }}
                      required
                      sx={commonTextFieldSx}
                    />
                  </Grid>
                }

                {activeTab === 'failedJobs' &&
                  <Grid item>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                      Upload To Date
                    </Typography>
                    <TextField
                      name="fromDate"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="medium"
                      value={toDate}
                      onChange={this.handleToDateChange}
                      inputProps={{
                        max: getMaxToDate(),
                        min: fromDate
                      }}
                      required
                      sx={commonTextFieldSx}
                    />
                  </Grid>
                }
                {activeTab === 'failedJobs' &&
                  <TextField
                    size="small"
                    placeholder="Search by Reason"
                    value={this.state.reason}
                    onChange={this.handleReasonChange.bind(this)}
                    sx={{
                      "& .MuiInputBase-input::placeholder": { fontSize: "11px" },
                      "& .MuiInputBase-input": { fontSize: "11px" },
                      width: 180,
                    }}
                  />
                }
                <Tooltip title="Click here for search result">
                  <IconButton
                    onClick={this.handleSearchClick}
                    sx={{
                      height: "33px",
                      border: "0.2px solid #d0bcbca1",
                      borderRadius: "9%",
                    }}
                  >
                    <Search fontSize="small" />
                  </IconButton>
                </Tooltip>

                {activeTab === 'failedJobs' &&
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: '#5bc0de',
                        fontSize: '0.75rem',
                        height: 30,
                        textTransform: 'none',
                        fontWeight: 'bold',
                      }}
                      onClick={this.handleExport}
                    >
                      Export as Excel
                    </Button>
                  </Grid>}

              </Box>

              {/* Right Section - Refresh */}
              <Tooltip title="Click here to refresh the table">
                <IconButton
                  onClick={() => {
                    this.handleResetClick();
                  }}
                  sx={{
                    height: "33px",
                    border: "0.2px solid #d0bcbca1",
                    borderRadius: "9%",
                    mr: 0.5,
                  }}
                >
                  <Cached fontSize="small" sx={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </Box>

            <div className="autojob-table-wrapper">
              <table className="autojob-table">
                <thead>
                  <tr className="autojob-table-row">
                    <th>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={(e) => this.handleSelectAll(e.target.checked)} // Handle "Select All"
                      />
                    </th>
                    <th>S.No.</th>
                    {activeTab === 'failedJobs' &&
                      <th>BrokerId</th>
                    }
                    <th>Folder Name</th>
                    {activeTab === 'failedJobs' &&
                      <th style={{ maxWidth: '250px' }}>Reason</th>
                    }
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.filteredJobList.length === 0 ? (
                    <tr>
                      <td
                        colSpan={4}
                        style={{ textAlign: "center", fontSize: "small" }}
                      >
                        No jobId is found for Reprocess
                      </td>
                    </tr>
                  ) : (
                    this.state.filteredJobList.map((job, index) => (
                      <tr key={job.JobId} className="autojob-table-row">
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedJob.has(job.FolderName)} // Check if the FolderName is in selectedJob
                            onChange={
                              (e) =>
                                this.handleCheckboxChange(
                                  job.FolderName,
                                  e.target.checked
                                ) // Handle individual checkbox changes
                            }
                          />
                        </td>
                        <td>{page * rowsPerPage + index + 1}</td>{" "}
                        {activeTab === 'failedJobs' &&
                          <td>{job.broker_id}</td>}
                        {/* Calculate the serial number */}
                        <td>{job?.FolderName}</td>
                        {activeTab === 'failedJobs' &&
                          <td style={{ maxWidth: '250px' }}>{job?.Reason}</td>
                        }
                        <td>{job?.CreatedDate}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <TablePagination
              component="div"
              count={this.state.totalCount}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              rowsPerPage={this.state.rowsPerPage}
              rowsPerPageOptions={[]} // disables dropdown
            />
          </div>
        );
      case "lobAlias":
        return (
          <div className="job-tab-content form-container">
            <div className="form-group">
              <input
                className="form-input compact"
                type="text"
                placeholder="LOB Alias name"
                value={lobAlias}
                onChange={(e) => this.handleChange("lobAlias", e.target.value)}
              />
              {errors?.lobAlias && (
                <div className="job-error">{errors.lobAlias}</div>
              )}
            </div>
            <div className="form-group">
              <input
                className="form-input compact"
                type="text"
                placeholder="LOB Code"
                value={lob}
                onChange={(e) => this.handleChange("lob", e.target.value)}
              />
              {errors.lob && <div className="job-error">{errors.lob}</div>}
            </div>
            <div className="form-group">
              <input
                className="form-input compact"
                type="text"
                placeholder="Ir Folder Lob Code"
                value={description}
                onChange={(e) =>
                  this.handleChange("description", e.target.value)
                }
              />
              {errors.description && (
                <div className="job-error">{errors.description}</div>
              )}
            </div>
            <button
              className="job-button small"
              onClick={this.openLobMappingDialog}
            >
              Map Lob
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const { displaysidebar } = this.props;
    const { activeTab, loading, snackbarOpen, snackbarMessage, snackbarSeverity, isDialogOpen, isDialogLobOpen, } = this.state;

    return (
      <>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              zIndex: 9999,
            }}
          >
            <div className="loader"></div>
          </Box>
        )}
        <GridTable displaysidebar={displaysidebar}>
          <div className="job-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => this.handleTabChange(tab.key)}
                className={`job-tab ${activeTab === tab.key ? "job-tab-active" : ""
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {this.renderTabContent()}
        </GridTable>

        {/* Confirmation Dialog for reprocess & retrigger*/}
        <Dialog open={isDialogOpen} onClose={this.handleCloseDialog}>
          <DialogContent
            sx={{
              padding: "0px 0px",
              width: "350px",
              paddingTop: "20px",
              paddingBottom: "25px",
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#FEF9C3",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Cached sx={{ color: "#CA8A04", fontSize: 30 }} />
              </Box>
            </Box>
            <DialogTitle
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "1.25rem",
                p: 0,
              }}
            >
              Confirm AutoJob Reprocess
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                sx={{
                  textAlign: "center",
                  padding: "2px 6px",
                  color: "rgba(0, 0, 0, 0.7)",
                }}
              >
                Are you sure you want to re-process the autojob{" "}
                <strong>{Array.from(this.state.selectedJob)}</strong>?
              </DialogContentText>
            </DialogContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                height: "30px",
              }}
            >
              <Button
                onClick={this.handleReprocessJobs}
                color="primary"
                variant="contained"
                autoFocus
              >
                Yes
              </Button>
              <Button
                onClick={this.handleCloseDialog}
                sx={{
                  color: "#007bff",
                  borderColor: "#007bff",
                  border: "0.5px solid #53494987",
                  "&:hover": {
                    borderColor: "#0056b3",
                    color: "#0056b3",
                  },
                }}
              >
                No
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Confirmation Dialog for Mapping Lob alais*/}
        <Dialog open={isDialogLobOpen} onClose={this.handleCloseDialog}>
          <DialogContent
            sx={{
              padding: "0px 0px",
              width: "320px",
              paddingTop: "15px",
              paddingBottom: "25px",
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#ECFDF5",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Add sx={{ color: "#2bdb17", fontSize: 30 }} />
              </Box>
            </Box>
            <DialogTitle
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "1.25rem",
                p: 0,
              }}
            >
              Create New Lob
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                sx={{
                  textAlign: "center",
                  padding: "10px 0px",
                  color: "rgba(0, 0, 0, 0.7)",
                }}
              >
                Are you sure of adding a new Lob!
              </DialogContentText>
            </DialogContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                height: "30px",
              }}
            >
              <Button
                onClick={this.handleLOBSubmit}
                color="primary"
                variant="contained"
                autoFocus
              >
                Yes
              </Button>
              <Button
                onClick={this.handleCloseDialog}
                sx={{
                  color: "#007bff",
                  borderColor: "#007bff",
                  border: "0.5px solid #53494987",
                  "&:hover": {
                    borderColor: "#0056b3",
                    color: "#0056b3",
                  },
                }}
              >
                No
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={2500}
          onClose={this.handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

export default JobMaintenance;
